<!-- dashboard.component.html -->
<div class="container-fluid pb-5">
    <h1 class="page-header mb-2 mb-lg-0">Dashboard</h1>
    <!-- Key Metrics Section -->
    <div class="metrics-section" *ngIf="canViewAnyMetric">

      <div class="row">
      <div class="col-lg-3 col-md-6 mb-4" *ngIf="canViewStudentMetrics">
        <app-metric-card
          [title]="metrics.active_students.label"
          [value]="metrics.active_students.value"
          icon="people"
          [subtitle]="metrics.active_students.sublabel"
          [trend]="metrics.active_students.trend"
          [trendValue]="metrics.active_students.trend_label"
          color="primary"
          [loading]="metricsLoading">
        </app-metric-card>
      </div>

      <div class="col-lg-3 col-md-6 mb-4" *ngIf="canViewCalendarMetrics">
        <app-metric-card
          [title]="metrics.classes_today.label"
          [value]="metrics.classes_today.value"
          icon="event"
          [subtitle]="metrics.classes_today.sublabel"
          [trend]="metrics.classes_today.trend"
          [trendValue]="metrics.classes_today.trend_label"
          color="success"
          [loading]="metricsLoading">
        </app-metric-card>
      </div>

      <div class="col-lg-3 col-md-6 mb-4" *ngIf="canViewPaymentMetrics">
        <app-metric-card
          [title]="metrics.revenue_mtd.label"
          [value]="metrics.revenue_mtd.value"
          icon="attach_money"
          [subtitle]="metrics.revenue_mtd.sublabel"
          [trend]="metrics.revenue_mtd.trend"
          [trendValue]="metrics.revenue_mtd.trend_label"
          color="info"
          [loading]="metricsLoading">
        </app-metric-card>
      </div>

      <div class="col-lg-3 col-md-6 mb-4" *ngIf="canViewPaymentMetrics">
        <app-metric-card
          [title]="metrics.pending_payments.label"
          [value]="metrics.pending_payments.value"
          icon="schedule"
          [subtitle]="metrics.pending_payments.sublabel"
          [trend]="metrics.pending_payments.trend"
          [trendValue]="metrics.pending_payments.trend_label"
          color="warning"
          [loading]="metricsLoading">
        </app-metric-card>
      </div>
    </div>
  </div>

  <!-- Quick Actions Section -->
  <div class="quick-actions-section mb-4">
    <app-quick-actions (actionClicked)="onQuickActionClicked($event)"></app-quick-actions>
  </div>

  <!-- Main Content Grid -->
  <div class="row">
    <!-- Left Column - Charts -->
    <div class="col-lg-9">
      <!-- Inquiry Summary Card -->
      <mat-card class="inquiry-summary-card mb-4" *ngIf="dashboardData && canViewReportsSection">
        <mat-card-header>
          <mat-card-title>{{ 'REPORTS.INQUIRY' | translate }} Summary</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="row">
            <div class="col-md-4">
              <div class="inquiry-metric">
                <div class="metric-circle contact">
                  <span class="metric-number">{{ dashboardData['#contact']?.current || 0 }}</span>
                </div>
                <div class="metric-label">
                  <div>{{ 'DASHBOARD.STUDENT_SUMMARY.CONTACT' | translate }}</div>
                  <div class="metric-comparison">
                    <span>Current: {{ dashboardData['#contact']?.current || 0 }}</span>
                    <span class="separator">|</span>
                    <span>Previous: {{ dashboardData['#contact']?.previous || 0 }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="inquiry-metric">
                <div class="metric-circle booked">
                  <span class="metric-number">{{ dashboardData['#booked']?.current || 0 }}</span>
                </div>
                <div class="metric-label">
                  <div>{{ 'DASHBOARD.STUDENT_SUMMARY.BOOKED' | translate }}</div>
                  <div class="metric-comparison">
                    <span>Current: {{ dashboardData['#booked']?.current || 0 }}</span>
                    <span class="separator">|</span>
                    <span>Previous: {{ dashboardData['#booked']?.previous || 0 }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="inquiry-metric">
                <div class="metric-circle showed">
                  <span class="metric-number">{{ dashboardData['#showed']?.current || 0 }}</span>
                </div>
                <div class="metric-label">
                  <div>{{ 'DASHBOARD.STUDENT_SUMMARY.SHOWED' | translate }}</div>
                  <div class="metric-comparison">
                    <span>Current: {{ dashboardData['#showed']?.current || 0 }}</span>
                    <span class="separator">|</span>
                    <span>Previous: {{ dashboardData['#showed']?.previous || 0 }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Charts Section -->
      <div class="row" *ngIf="canViewReportsSection">
        <div class="col-xl-6 col-lg-12 mb-4">
          <mat-card class="chart-card h-100">
            <mat-card-header>
              <mat-card-title>Lessons Booked</mat-card-title>
            </mat-card-header>
            <mat-card-content class="chart-content">
              <app-lessons-booked-chart [chart_data]="chart_data?.['lessons_booked']"></app-lessons-booked-chart>
            </mat-card-content>
          </mat-card>
        </div>

        <div class="col-xl-6 col-lg-12 mb-4">
          <mat-card class="chart-card h-100">
            <mat-card-header>
              <mat-card-title>Payment Overview</mat-card-title>
            </mat-card-header>
            <mat-card-content class="chart-content">
              <app-payments-chart [chart_data]="chart_data?.['payments']"></app-payments-chart>
            </mat-card-content>
          </mat-card>
        </div>

        <div class="col-12 mb-4" *ngIf="canViewStudentMetrics">
          <mat-card class="chart-card">
            <mat-card-header>
              <mat-card-title>Active Student Accounts (weekly)</mat-card-title>
            </mat-card-header>
            <mat-card-content class="chart-content">
              <app-active-students-chart></app-active-students-chart>
            </mat-card-content>
          </mat-card>
        </div>

        <div class="col-12 mb-4">
          <mat-card class="chart-card">
            <mat-card-header>
              <mat-card-title>Enrollment Trends</mat-card-title>
            </mat-card-header>
            <mat-card-content class="chart-content">
              <app-enrollments-chart [chart_data]="chart_data?.['enrollment']"></app-enrollments-chart>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>

    <!-- Right Column - Activity Feed -->
    <div class="col-lg-3" *ngIf="canViewActivity">
      <div class="activity-column">
        <app-activity-feed></app-activity-feed>
      </div>
    </div>
</div>
